// src/screens/ProductsScreen.jsx
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../redux/features/Product/productThunk';
import Loader from '../components/Loader';
import Message from '../components/Message';
import ProductCard from '../components/ui/ProductCard';
import ErrorBoundary from '../components/ErrorBoundary';

function ProductsScreen() {
  const dispatch = useDispatch();
  const { loading, error, products } = useSelector((state) => state.listProduct);

  useEffect(() => {
    if (!products || products.length === 0) {
      dispatch(fetchProducts());
    }
  }, [dispatch, products]);

  // ✅ مرتب‌سازی: موجودها بالا، ناموجودها پایین
  const sortedProducts = useMemo(() => {
    if (!products || products.length === 0) return [];

    return [...products].sort((a, b) => {
      const aInStock = a.countInStock > 0;
      const bInStock = b.countInStock > 0;

      if (aInStock && !bInStock) return -1;
      if (!aInStock && bInStock) return 1;

      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  }, [products]);

  const productList = Array.isArray(sortedProducts) ? sortedProducts : [];

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">همه محصولات</h1>

      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger" text={error} />
      ) : productList.length === 0 ? (
        <Message variant="info" text="هیچ محصولی یافت نشد." />
      ) : (
        <ErrorBoundary
          fallbackMessage="مشکلی در نمایش محصولات پیش آمد."
          onRetry={() => dispatch(fetchProducts())}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {productList.map((product) => (
              <ProductCard key={product._id} {...product} />
            ))}
          </div>
        </ErrorBoundary>
      )}
    </div>
  );
}

export default ProductsScreen;